import { useQuery } from "@tanstack/react-query";

import Loading from "@/app/loading";
import FetchError from "@/components/ui/fetch-error";
import Icon from "@/components/ui/icon";

import api from "@/lib/api";

type PubItemModalData = {
  title: string;
  abstract: string;
  authors: string[];
  studies: string[];
  topic_tags: string[];
  type: string;
  doi: string;
  source: string;
  info: string;
  year: number;
  url: string;
};

export default function PublicationItemModal({ itemId }: { itemId: number }) {
  const { data, error, isPending } = useQuery({
    queryKey: ["pub-item-search-modal", itemId],
    queryFn: () => api.get<PubItemModalData>(`/pub/item/${itemId}`),
    enabled: !!itemId,
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  return (
    <>
      <div className="container">
        <div className="row g2-text-grey">
          <h6 className="text-dark">Title</h6>
          <p className="mb-4">{data["title"]}</p>
          <h6 className="text-dark">Abstract</h6>
          <p className="mb-4">{data["abstract"]}</p>
          <h6 className="text-dark">Authors</h6>
          <div className="mb-3">
            {(data["authors"] as string[]).map((item: string) => (
              <span className="g2-label" key={item}>
                {item}
              </span>
            ))}
          </div>

          <h6 className="text-dark">Survey</h6>
          <div className="mb-3">
            {(data["studies"] as string[]).map((item: string) => (
              <span className="g2-label" key={item}>
                {item}
              </span>
            ))}
          </div>
          <h6 className="text-dark">Topic</h6>
          <div className="mb-3">
            {(data["topic_tags"] as string[]).map((item: string) => (
              <span className="g2-label" key={item}>
                {item}
              </span>
            ))}
          </div>
          <h6 className="text-dark">Type</h6>
          <p className="mb-4">{data["type"] || "-"}</p>
          <h6 className="text-dark">DOI</h6>
          <p className="mb-4">{data["doi"] || "-"}</p>
          <h6 className="text-dark">Source</h6>
          <p className="mb-4">{data["source"] || "-"}</p>
          <h6 className="text-dark">Issue</h6>
          <p className="mb-4">{data["info"] || "-"}</p>
          <h6 className="text-dark">Year</h6>
          <p>{data["year"] || "-"}</p>
          <a className="g2-link-blue" target="_blank" href={data.url}>
            Direct Link <Icon icon="box-arrow-up-right" ms={2} />
          </a>
        </div>
      </div>
    </>
  );
}
